import { ItemData } from 'core/models/Template'

export const PITAMIX_CATALOG_TYPE = 'pitamix' as const
export const PITAMIX_CATALOG_TITLE_KEY = 'pitamixCatalog' as const

export const PITAMIX_CATALOG_CONFIG = {
    type: PITAMIX_CATALOG_TYPE,
    isWebAppTitle: true,
    additionalData: {},
} as const

export type PitamixSelectedItems = ItemData[]
